import { agentProfileIdSchema } from "./profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/protocol/wake-device-wait.ts
const MAX_WAKE_DEVICE_WAIT_MS = 10080 * 6e4;
const DEFAULT_WAKE_DEVICE_WAIT_MS = 1440 * 6e4;
const RUNTIME_COORDINATOR_DEVICE_WAITING_REASON_CODE = "runtime_coordinator.device_waiting";
const wakeDeviceWaitTargetSchema = z$1.strictObject({
	bindingId: z$1.string().trim().min(1).max(512),
	openMeldServiceRuntimeId: z$1.string().trim().min(1).max(512)
});
const wakeDeviceWaitSchema = wakeDeviceWaitTargetSchema.extend({
	deadlineAtMs: z$1.number().int().nonnegative(),
	targetProfileId: agentProfileIdSchema
});
const wakeDeviceWaitAccessRequestSchema = z$1.strictObject({
	dispatchId: z$1.string().trim().min(1),
	sourceSignalId: z$1.string().trim().min(1),
	spaceId: z$1.string().trim().min(1),
	targetProfileId: agentProfileIdSchema
});
const wakeDeviceWaitAccessResponseSchema = z$1.strictObject({ allowed: z$1.boolean() });
//#endregion
export { DEFAULT_WAKE_DEVICE_WAIT_MS, MAX_WAKE_DEVICE_WAIT_MS, RUNTIME_COORDINATOR_DEVICE_WAITING_REASON_CODE, wakeDeviceWaitAccessRequestSchema, wakeDeviceWaitAccessResponseSchema, wakeDeviceWaitSchema, wakeDeviceWaitTargetSchema };

//# sourceMappingURL=wake-device-wait.js.map